import React from 'react';
import AppText from "./AppText";
import {TouchableOpacity, ActivityIndicator} from "react-native";
interface IProps {
    text:string;
    onPress:Function;
    isLoading?:boolean;
    width?:number;
    height?:number;
    color?:string;
    fontSize?:number;
}

export default class AppButton extends React.Component<IProps>{
    render() {
        return (
            <TouchableOpacity disabled={this.props.isLoading} onPress={()=>this.props.onPress()} style={{width:this.props.width?this.props.width:55,height:this.props.height?this.props.height:30,backgroundColor:this.props.color?this.props.color:'#019FB2',marginLeft:10,justifyContent:'center',alignItems:'center',borderRadius:25}}>
                {
                    this.props.isLoading?
                        <ActivityIndicator size="small" color="#fff" />
                        :<AppText style={{color:'#fff',fontWeight:'500',fontSize:this.props.fontSize?this.props.fontSize:14}}>{this.props.text}</AppText>
                }
            </TouchableOpacity>
        )
    }
}
